
import { v4 as uuidv4 } from 'uuid';
export type Port = {
  /** 连接点ID */
  id: string;
  /** 数据类型 */
  dataType: string;
  /** 允许连接的类�?*/
  allowTypes?: string[];
  /** 显示名称 */
  name: string;
  /** 附加信息 */
  info?: {
    /** 说明 */
    description?: { 
      zh: string; 
      en: string; 
    };
    /** 外观 */
    style?: { 
      color?: string; 
      icon?: string; 
    };
  };
};
type NodeType = {
  id: string;
  type: string;
  position: { x: number; y: number };
  label: string;
  data:{
      componentType: string | null;
      parentData: Record<string, any>;
      bgColor?: string;
      handles?: {
        inputs: Port[],
        outputs: Port[]
      },
      config?:unknown,
      propertyPanel?:unknown
  }
};

function onDragOver(event: DragEvent) {
  event.preventDefault();
}
function onDragLeave(event: DragEvent) {
  event.preventDefault();
}

function onDrop(event: DragEvent,viewport:any,addNode:any): void {

  
  const rawX = event.clientX;
  const rawY = event.clientY;
  if (event.target instanceof HTMLElement) {
    const rect = event.target.getBoundingClientRect();
    const localX = rawX - rect.left;
    const localY = rawY - rect.top;
    const adjustedX = (localX - viewport.x) / viewport.zoom;
    const adjustedY = (localY - viewport.y) / viewport.zoom;
    const data = JSON.parse(event.dataTransfer?.getData('node') || '{}');
    const node: NodeType = {
      id: uuidv4(),
      type: data.component,
    
      position: { x: adjustedX - 120, y: adjustedY },
      label: data.label,
      data: {
        componentType: data?.componentType,
        parentData: {},
        bgColor:data?.bgColor,
      },
     
    };
   // 拖拽节点
   addNode(node);
  }
}

export { onDrop, onDragOver, onDragLeave };
